export default __webpack_public_path__ + "static/media/pause.bbc8fac2.svg";